<template>
    <div>
        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-if="showConclusion == false">
            <v-card-title class="primary">
                <v-toolbar-title id="titulocard"> Autorizar Conclusión</v-toolbar-title>
            </v-card-title>
            <v-card-text>
                <v-row justify="center" v-if="loaded == false">
                    <v-col cols="12" md="7">
                        <v-skeleton-loader
                            type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                    </v-col>
                </v-row>
                <div>
                    <v-row justify="center" v-if="loaded == true">
                        <v-col cols="12" md="10">
                            <div>
                                <table>
                                    <thead>
                                        <tr>
                                            <th>NA</th>
                                            <th>NO</th>
                                            <th>SI</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(pregunta, index) in preguntas" :key="index">
                                            <td>
                                                <v-radio-group v-model="respcheck[index]" row>
                                                    <v-radio :value="pregunta.veid + ':NA'"
                                                        :name="pregunta.veid.toString()"
                                                        v-if="pregunta.vecheckna == 1"></v-radio>
                                                </v-radio-group>
                                            </td>
                                            <td>
                                                <v-radio-group v-model="respcheck[index]" row>
                                                    <v-radio :value="pregunta.veid + ':N'"
                                                        :name="pregunta.veid.toString()"></v-radio>
                                                </v-radio-group>
                                            </td>
                                            <td align="center">
                                                <v-radio-group v-model="respcheck[index]" row>
                                                    <v-radio :value="pregunta.veid + ':S'"
                                                        :name="pregunta.veid.toString()"
                                                        @click="ValidarMovimiento(pregunta.veid, index)"></v-radio>
                                                </v-radio-group>
                                            </td>
                                            <td>
                                                {{ pregunta.vepregunta }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <v-row justify="center" class="mb-8">
                    <v-btn class="ma-2" color="#536DFE" style="color:white" @click="saveCheckEjecutivo()"
                        :disabled="disBtn">Siguiente</v-btn>
                    <v-btn class="ma-2" color="error" @click="cancelar()" :disabled="disBtn">Cancelar</v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-else>
            <v-card-title class="primary">
                <v-toolbar-title id="titulocard"> Autorizar Conclusión</v-toolbar-title>
            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center" v-if="loaded == false">
                        <v-col cols="12" md="7">
                            <v-skeleton-loader
                                type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"></v-skeleton-loader>
                        </v-col>
                    </v-row>
                    <v-row justify="center" v-else>
                        <v-col cols="12" md="7">
                            <span class="type-label-style">Fecha del movimiento:</span>
                            <v-dialog ref="dialogfh" outlined v-model="modalfh" :return-value.sync="selectedDate"
                                persistent width="290px">
                                <template v-slot:activator="{ on, attrs }">
                                    <div class="date-align-center">
                                        <v-text-field class="pt-2" v-model="selectedDate" label="" outlined dense
                                            v-bind="attrs" v-on="on" readonly>
                                        </v-text-field>
                                    </div>
                                </template>
                                <v-date-picker v-model="selectedDate" :min="dateComponentConstraints.fechaMinima"
                                    :max="dateComponentConstraints.fechaMaxima" locale="es" scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="secondary" @click="modalfh = false">Cancelar</v-btn>
                                    <v-btn text color="primary" @click="$refs.dialogfh.save(selectedDate)">
                                        OK
                                    </v-btn>
                                </v-date-picker>
                            </v-dialog>
                            <v-divider class="mt-1"></v-divider>
                            <div>
                                <span class="type-label-style">Tipo de Conclusión:</span>
                                <p class="type-text-style">Visto bueno del ejecutivo para conclusión</p>
                            </div>
                            <v-divider class="mt-1"></v-divider>
                            <div>
                                <span class="type-label-style">¿Se autoriza la conclusión?:</span>
                                <v-radio-group :error-messages="errorRadio" v-model="respuesta" row>
                                    <v-radio label="SI" value="S" :readonly="respNo"></v-radio>
                                    <v-radio label="NO" value="N" :readonly="respNo"></v-radio>
                                </v-radio-group>
                            </div>
                            <div class="mt-2">
                                <span class="type-label-style">Firma Electrónica Avanzada:</span>
                                <v-text-field v-model="efirma" outlined autocomplete="off" maxlength="17" dense
                                    @focus="msg = false;" label="" style="-webkit-text-security: disc;"></v-text-field>
                                <span v-if="msg" id="revfirmaelectronica" style="color: #FF5C93; font-size: 12px;"
                                    class="mt-0">{{ texto }}</span>
                            </div>
                            <div class="mt-4">
                                <span class="type-label-style">Observaciones:</span>
                                <v-textarea style="padding-left: 0px !important;" v-on:blur=" observaciones != null ? observaciones != '' ? observaciones = observaciones.trim() : null : null
            " v-model="observaciones" id="textareaobs" :rules="rulestextarea" outlined
                                    :maxlength="$store.state.maxLengthComentarios"
                                    :counter="$store.state.maxLengthComentarios"></v-textarea>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                    <v-row justify="center" class="mb-8">
                        <v-btn class="ma-2" color="#536DFE" style="color:white" @click="saveMovimiento()"
                            :disabled="disBtn">Guardar</v-btn>
                        <v-btn class="ma-2" color="error" @click="cancelar()" :disabled="disBtn">Cancelar</v-btn>
                    </v-row>
                </v-card-actions>
            </v-form>
        </v-card>
        <v-dialog transition="dialog-top-transition" persistent max-width="600" v-model="modalfirma">
            <v-card>
                <v-card-title class="primary">
                    <v-toolbar-title id="titulocard"> Autorizar movimientos con respuesta NO APLICA</v-toolbar-title>
                </v-card-title>
                <v-card-text>
                    <span class="type-label-style">Firma electrónica:</span>
                    <br />
                    <v-text-field v-model="efirma" outlined autocomplete="off" maxlength="17"
                        style="-webkit-text-security: disc;" autofocus dense @focus="msg = false;"></v-text-field>
                    <span v-if="msg" id="revfirmaelectronica" style="color: #FF5C93" class="mt-0">{{ texto }}</span>
                    <br />
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn @click="CerrarModal()" color="default">Cerrar</v-btn>
                    <v-btn @click="ValidarFirma(1)" color="primary" :loading="loading"
                        :disabled="loading">Aceptar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>

import { mapActions, mapMutations, mapState, mapGetters } from 'vuex';
import ConclusionServ from '@/services/Conclusion/Conclusion.service.js';
import reporteGeneral from '@/services/ReporteGeneral/ReporteGeneral.service.js';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";

export default {
    title() {
        return this.$route.meta.title
    },
    data() {
        return {
            loaded: false,
            disBtn: true,
            respNo: false,
            preguntas: [],
            respcheck: [],
            isValidated: [],
            modalfirma: false,
            efirma: '',
            texto: '',
            msg: false,
            loading: false,
            showConclusion: false,
            modalfh: false,
            selectedDate: "",
            dateCollabsable: false,
            dateComponentConstraints: {},
            respuesta: null,
            /* validarespuesta: false, */
            observaciones: "",
            rulestextarea: [
                (v) => !!v || "Campo requerido",
                (v) => {
                    if (v == null) {
                        return true;
                    } else {
                        if (v.trim().length < 16) {
                            return "Mínimo 16 Carácteres";
                        } else if (v.trim().length > this.$store.state.maxLengthComentarios) {
                            return "Máximo " + this.$store.state.maxLengthComentarios + " Carácteres";
                        } else return true;
                    }
                },
            ],
            respread: false,
            validForm: true,
            reporte: {},
            errorRadio: '',
        };
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
    watch: {
        'respuesta'(val) {
            if (val != null) {
                this.errorRadio = "";
            }
        }
    },
    async mounted() {
        this.changeReporteMenuOption("NoView");
        this.reporte = await MetodosGenerales.obtenerSessionReporte("reporte");
        let valestatus = await MetodosGenerales.getReporteEstatus(this);
        if (valestatus == 2) {
            this.$router.go(-1);
        } else {
            let val = await ConclusionServ.ValidarAutorizarConclusion(this.reporte);
            if (val == 1) {
                this.preguntas = await ConclusionServ.ObtenerPreguntas(this.reporte);
                if (this.preguntas.length == 0) {
                    this.showConclusion = true;
                }
                await this.getDatosGenerales();
            } else {
                this.$swal({
                    position: "center",
                    icon: "info",
                    title: "Validación",
                    html: "No tiene los datos necesarios para continuar con la Autorización de Conclusión.",
                    confirmButtonText: "Aceptar",
                    confirmButtonColor: '#536DFE',
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    timer: 4500,
                }).then(() => {
                    this.$router.go(-1);
                });
            }
        }


    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        handleCopy(event) {
            event.preventDefault();
        },
        cancelar() {
            this.$router.go(-1);
        },
        async getDatosGenerales() {
            let today = new Date().toJSON().slice(0, 10);
            this.selectedDate = today;
            this.dateComponentConstraints.fechaMaxima = today;
            let response = await reporteGeneral.fechaSvreporte(this, this.reporte);
            this.dateComponentConstraints.fechaMinima = response[0]["svfhreporte"];
            this.loaded = true;
            this.dateCollabsable = true;
            this.disBtn = false;
        },
        async ValidarMovimiento(veid, index) {
            this.disBtn = true;
            let response = await ConclusionServ.ValidarPreg(this.reporte, veid);
            if (response != null) {
                this.$set(this.respcheck, index, null);
                this.$swal({
                    position: "center",
                    icon: "warning",
                    title: "Alerta",
                    html: `${response}`,
                    confirmButtonText: "Aceptar",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowHtmlTags: true,
                }).then(() => {
                    this.disBtn = false;
                });
            } else {
                this.disBtn = false;
            }
        },
        checkAllSelected() {
            if (this.respcheck.length != 0) {
                if (this.respcheck.length == this.preguntas.length) {
                    for (const respuesta of this.respcheck) {
                        if (!respuesta) {
                            return false; // Si alguna respuesta es falsa (null o undefined), no todos están seleccionados
                        }
                    }
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        CerrarModal() {
            this.modalfirma = false;
            this.efirma = '';
            this.texto = '';
        },
        async saveCheckEjecutivo() {
            this.disBtn = true;
            if (this.checkAllSelected()) {
                this.respNo = this.respcheck.some(registro => registro.includes('N') && !registro.includes('NA'));
                const preguntasConNA = this.respcheck.filter(registro => registro.includes('NA')).map(registro => parseInt(registro.replace('NA', '')));
                this.respuesta = this.respNo == true ? 'N' : null;
                if (preguntasConNA.length > 0) {
                    let response = await ConclusionServ.ValidacionNA(preguntasConNA.join(', '));
                    this.$swal({
                        position: "center",
                        icon: "warning",
                        title: "Alerta",
                        html: `${response}`,
                        showCancelButton: true,
                        allowOutsideClick: false,
                        confirmButtonColor: '#536DFE',
                        cancelButtonColor: '#FF5C93',
                        confirmButtonText: 'Aceptar',
                        cancelButtonText: 'Cancelar',
                        allowHtmlTags: true,
                    }).then(async (result) => {
                        if (result.value) {
                            this.modalfirma = true;
                        }
                    })
                } else {
                    await this.GuardarValidacionEjec(this.respcheck, 0, 1, 0, 1);
                }
            } else {
                this.$swal({
                    position: "center",
                    icon: "warning",
                    title: "Alerta",
                    text: "Debes seleccionar una respuesta para cada pregunta antes de guardar.",
                    confirmButtonText: "Aceptar",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                });
            }
            this.disBtn = false;
        },
        async ValidarFirma(tipo) {
            if (this.efirma.length == 0) {
                this.msg = true;
                this.texto = 'Campo de rquerido';
            }
            else if (this.efirma.length < 8 || this.efirma.length > 16) {
                this.msg = true;
                this.texto = 'El número de caracteres debe ser un mínimo de 8 y menor a 17';
            }
            else {
                this.loading = true;
                let eFirmaValidResponse = await ConclusionServ.ValidarEFirma(this.efirma);
                if (eFirmaValidResponse.length == 1) {
                    if (tipo == 1) {
                        this.modalfirma = false;
                        await this.GuardarValidacionEjec(this.respcheck, 0, 1, 1, 1);
                    } else {
                        return true;
                    }

                } else {
                    this.msg = true;
                    this.texto = 'Su firma electrónica es incorrecta';
                }
                this.efirma = '';
                this.loading = false;
            }
        },
        async GuardarValidacionEjec(resp, estatus, tipo, firma, auxVal) {
            if (auxVal == 1) { this.loaded = false; }
            let response = await ConclusionServ.GuardarValidacionEjec(this.reporte, resp.join(', '), estatus, tipo, firma);
            if (auxVal == 1) {
                this.showConclusion = true;
                this.loaded = true;
                this.disBtn = false;
                if (this.respuesta == 'N') {
                    this.$swal({
                        position: "center",
                        icon: "info",
                        title: "Información",
                        text: "No se le permitirá ingresar una respuesta SI, ya que hay alguna pregunta con respuesta NO, sus respuestas deberán tener respuesta SI o NO APLICA para poder continuar.",
                        confirmButtonText: "Aceptar",
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    });
                }
            } else {
                this.$swal({
                    position: "center",
                    title: "Cargando...",
                    html: "Espere un momento por favor",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    confirm: false,
                });
                this.$swal.showLoading();
                let respuesta = await ConclusionServ.GuardarAutorizarConclucion(this.reporte, this.respuesta, this.observaciones, this.selectedDate)
                if (respuesta == true) {
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: "Éxito!",
                        html: "Se realizó el movimiento de Autorización de Conclusión",
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: '#536DFE',
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        timer: 3500,
                    }).then(() => {
                        this.$router.go(-1);
                    });
                } else {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Error al guardar la Autorización de Conclusión",
                        html: "Hubo un error inténtelo de nuevo",
                        showConfirmButton: false,
                        confirmButtonText: "Aceptar",
                        confirmButtonColor: '#536DFE',
                        showConfirmButton: true,

                    });
                    this.disBtn = false;
                }
            }

        },
        async saveMovimiento() {
            this.disBtn = true;
            this.errorRadio = (this.respuesta == null || this.respuesta == '') ? 'Campo requerido' : '';
            if (this.efirma.length == 0) {
                this.msg = true;
                this.texto = 'Campo de rquerido';
            }
            if (this.$refs.form.validate() && await this.ValidarFirma(2) && this.errorRadio == '') {
                await this.GuardarValidacionEjec(this.respcheck, 1, 2, 0, 2);
            } else {
                this.disBtn = false;
            }
        },
    },
};
</script>
<style>
.col_checkejec {
    justify-items: center;
    display: grid;
}

.type-text-style {
    font-family: "Poppins", sans-serif;
    font-weight: 700;
    font-size: 1.3em;
}
</style>
